module.exports = __webpack_public_path__ + "img/DPDMini.684e68ea.png";